// extracted by mini-css-extract-plugin
export var info = "styles-module--info--VV4wC";
export var readInfo = "styles-module--read-info--FFbot";
export var tag = "styles-module--tag--BdrGq";
export var afterIcon = "styles-module--after-icon--+O4gE";